<template>
  <b-modal
    :visible="isOpen"
    id="add-init"
    size="xl"
    :title="title"
    header-bg-variant="light"
    header-text-variant="dark"
    footer-bg-variant="light"
    footer-text-variant="dark"
    :hide-footer="isPreview"
    @hide="$emit('close')"
    ok-title="Next"
    @ok="handleOkClick"
    :ok-disabled="!fleets.checkeds.length"
  >
    <b-row class="mb-4">
      <b-col md="4" class="text-right">
        <b-form-input
          type="text"
          placeholder="Search fleets..."
          v-model="fleets.params.search"
        ></b-form-input>
      </b-col>
    </b-row>
    <div v-if="fleets.loading" class="text-center my-5">
      <b-spinner type="grow" label="Spinning"></b-spinner>
    </div>
    <template v-else>
      <div
        v-if="filteredFleets?.length > 0"
        style="max-height: 68vh; overflow: auto"
      >
        <b-row class="w-100">
          <b-col
            md="3"
            class="text-center pb-5 border-top"
            v-for="(fleet, i) in filteredFleets"
            :key="`fleet-${i}`"
          >
            <div>
              <label :for="`ck-fl-${i}`" style="cursor: pointer">
                <img
                  :src="
                    fleet?.vehicle_type?.icon?.url
                      | checkPhoto(
                        require('@src/assets/images/fleet/PusherBarge.png')
                      )
                  "
                  alt="#"
                  class="img-fluid"
                />
                <div
                  class="d-flex justify-content-center align-items-center mt-2"
                >
                  <b-form-checkbox
                    v-if="!isPreview"
                    :id="`ck-fl-${i}`"
                    :value="fleet.vehicle_id"
                    v-model="fleets.checkeds"
                  />
                  <strong>
                    {{ fleet?.vehicle_name || fleet?.vehicle?.name }}
                  </strong>
                </div>
              </label>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else class="text-center my-5">
        <p class="mb-0 text-muted">No fleets data found.</p>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { fleetsActions, pmsActions } from '@/src/Utils/helper'

export default {
  name: 'SelectFleetJobLibrary',
  props: {
    isOpen: Boolean,
    isPreview: Boolean,
    jobLibraryIds: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Select Fleets',
    },
    fleetsSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fleets: {
        checkeds: [],
        data: [],
        loading: false,
        params: {
          page: 1,
          limit: 999,
          search: '',
        },
      },
    }
  },
  computed: {
    filteredFleets() {
      // Jika fleetsSelected ada datanya, gunakan fleetsSelected sebagai data source
      const dataSource =
        this.fleetsSelected.length > 0 ? this.fleetsSelected : this.fleets.data

      if (!this.fleets.params.search) {
        return dataSource
      }

      const searchTerm = this.fleets.params.search.toLowerCase()
      return dataSource?.filter(
        (fleet) =>
          fleet?.vehicle_name?.toLowerCase().includes(searchTerm) ||
          fleet?.vehicle?.name?.toLowerCase().includes(searchTerm)
      )
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal == true && this.jobLibraryIds.length > 0) {
        this.fetchFleets()
        this.fleets.checkeds = []
      }
    },
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,
    async fetchFleets() {
      this.fleets.loading = true
      let params = {
        job_library_id: this.jobLibraryIds.toString(),
      }
      let res = await this.getVehicleForAssignJob(params)
      if (!res.status) {
        this.fleets.loading = false
        this.fleets.data = []
      } else {
        this.fleets.loading = false
        this.fleets.data = res.data
      }
    },
    showAlert() {
      this.$swal('Gagagl!!', 'Pilih Kapal Terlebih Dahulu!', 'error')
    },
    handleOkClick() {
      if (this.fleets.checkeds.length === 0) {
        this.showAlert()
        return false // Mencegah modal tertutup
      }

      // Filter fleets.data yang hanya ada di checkeds
      const selectedFleets = this.fleets?.data?.filter((fleet) =>
        this.fleets.checkeds.includes(fleet.vehicle_id)
      )

      // Emit data yang sudah difilter
      this.$emit('next', selectedFleets)
      return true // Memungkinkan modal tertutup
    },
  },
  mounted() {
    if (this.jobLibraryIds.length > 0 && !this.isPreview) {
      this.fetchFleets()
    }
  },
}
</script>
